import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiNeutralFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1C2.375 1 1 2.375 1 12s1.375 11 11 11 11-1.375 11-11S21.625 1 12 1M9 16.1v1.8h6v-1.8zm8.5-5.7h-4V8.6h4zm-11 0h4V8.6h-4z"
            fill="currentColor"
        />
    </svg>
));
EmojiNeutralFilledSize24Glyph.displayName = 'EmojiNeutralFilledSize24Glyph';
